"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateDiff = void 0;
const timeSpan_1 = require("./timeSpan");
/**
 * Oblicza różnicę pomiędzy datami
 * @param lateDate data późniejsza
 * @param earlyDate data wcześniejsza
 */
function dateDiff(lateDate, earlyDate) {
    return timeSpan_1.TimeSpan.diff(lateDate, earlyDate);
}
exports.dateDiff = dateDiff;
//# sourceMappingURL=dateDiff.js.map